import { MoldOrder } from '../types/mold';

export const sortMoldOrder = (orders: MoldOrder[]): MoldOrder[] => {
    return orders.sort((a, b) => sortSingleMoldOrder(a, b));
}

// Copy-sort by raw priority only. Distinct from sortMoldOrder, which mutates in
// place and applies due-date/shift tie-breakers; the mold-order list/card views
// intentionally order by priority alone.
export const sortByPriority = (orders: MoldOrder[]): MoldOrder[] =>
    [...orders].sort((a, b) => a.priority - b.priority);

export const sortSingleMoldOrder = (a: MoldOrder, b: MoldOrder): number => {
    // Default: Sort by priority
    if (a.priority !== b.priority) {
        return a.priority - b.priority;
    }

    // Special case: pending_arrival status
    if (a.status === 'pending_arrival' && b.status === 'pending_arrival') {
        // Sort by expectedArrivalDate (closest first)
        const dateA = a.orderDetail?.expectedArrivalDate ? new Date(a.orderDetail.expectedArrivalDate).setHours(0, 0, 0, 0) : Infinity;
        const dateB = b.orderDetail?.expectedArrivalDate ? new Date(b.orderDetail.expectedArrivalDate).setHours(0, 0, 0, 0) : Infinity;
        const diffDate = dateA - dateB;
        if (diffDate !== 0) return diffDate;
        // fallback to id if needed (stable sort)
        return (a.id ?? 0) - (b.id ?? 0);
    }
    
    // Sort by due date (DD-MM-YYYY level)
    if (a.orderDetail?.dueDate && b.orderDetail?.dueDate) {
        const dateA = new Date(a.orderDetail.dueDate).setHours(0, 0, 0, 0);
        const dateB = new Date(b.orderDetail.dueDate).setHours(0, 0, 0, 0);
        const diffDate = dateA - dateB;
        if (diffDate !== 0) return diffDate;
    }

    // Sort by shiftCompleted
    const shiftOrder = { 'A': 1, 'B': 2, undefined: 3 };
    const shiftComparison = shiftOrder[a.orderDetail.shiftCompleted ?? 'undefined'] - shiftOrder[b.orderDetail.shiftCompleted ?? 'undefined'];
    if (shiftComparison !== 0) return shiftComparison;

    return 0;
}